import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _challengeStats = {
    published: '_publishedChallengeStats',
    finished: '_finishedChallengeStats',
};
var _finishedChallengeStats = { completionRate: 'DOUBLE' };
var _getChallengeStatsRequest = {};
var _getChallengeStatsResponse = { challengeStats: '_challengeStats' };
var _getPremiumStatsRequest = {};
var _getPremiumStatsResponse = { stats: '_premiumStats' };
var _getQuizzesStatsRequest = {};
var _getQuizzesStatsResponse = {};
var _getStatsRequest = {};
var _getStatsResponse = {};
var _premiumStats = { gracePeriodEnd: 'google.protobuf.Timestamp' };
var _publishedChallengeStats = { completionRate: 'DOUBLE' };
function resolveComWixpressAchievementsApiV1StatsServiceUrl(opts) {
    var domainToMappings = {
        'editor._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
            {
                srcPath: '/challenges/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        'challenges.wixapps.net': [
            {
                srcPath: '/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/challenge-stats-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
            {
                srcPath: '/challenge-service-web/api/v1/premium-stats',
                destPath: '/api/v1/premium-stats',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
            {
                srcPath: '/challenge-service-web/api/v1/stats',
                destPath: '/api/v1/stats',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** @deprecated */
export function getStats(payload) {
    var _a = serializer(_getStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStatsResponse, {}).fromJSON;
    function __getStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge_stats',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.StatsService.GetStats',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                protoPath: '/api/v1/stats',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStats.fromReq = fromReq;
    __getStats.__isAmbassador = true;
    return __getStats;
}
export function getChallengeStats(payload) {
    var _a = serializer(_getChallengeStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getChallengeStatsResponse, {
        _challengeStats: _challengeStats,
        _finishedChallengeStats: _finishedChallengeStats,
        _publishedChallengeStats: _publishedChallengeStats,
    }).fromJSON;
    function __getChallengeStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge_stats',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.StatsService.GetChallengeStats',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                protoPath: '/api/v1/stats/{challengeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                        protoPath: '/api/v1/stats/{challengeId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getChallengeStats.fromReq = fromReq;
    __getChallengeStats.__isAmbassador = true;
    return __getChallengeStats;
}
export function getQuizzesStats(payload) {
    var _a = serializer(_getQuizzesStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getQuizzesStatsResponse, {}).fromJSON;
    function __getQuizzesStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge_stats',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.StatsService.GetQuizzesStats',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                protoPath: '/api/v1/stats/quizzes/{challengeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                        protoPath: '/api/v1/stats/quizzes/{challengeId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getQuizzesStats.fromReq = fromReq;
    __getQuizzesStats.__isAmbassador = true;
    return __getQuizzesStats;
}
export function getPremiumStats(payload) {
    var _a = serializer(_getPremiumStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPremiumStatsResponse, {
        _premiumStats: _premiumStats,
    }).fromJSON;
    function __getPremiumStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge_stats',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.StatsService.GetPremiumStats',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                protoPath: '/api/v1/premium-stats',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPremiumStats.fromReq = fromReq;
    __getPremiumStats.__isAmbassador = true;
    return __getPremiumStats;
}
//# sourceMappingURL=http.impl.js.map